import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, useScroll, useSpring } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Catalog from './components/Catalog';
import SEO from './components/SEO';

// Component to handle SEO for different routes
const RouteSEO = () => {
  const location = useLocation();

  if (location.pathname === '/catalog') {
    return (
      <SEO
        title="Product Catalog"
        description="Explore our comprehensive range of fire safety equipment including fire extinguishers, alarms, sprinkler systems, and more. Professional fire safety solutions meeting Indian Standards."
        keywords="fire safety equipment catalog, fire extinguishers, fire alarms, sprinkler systems, fire safety products, fire safety systems, fire protection equipment, India"
        url="https://kashyapengineering.co.in/catalog"
        type="website"
        publishedTime={new Date().toISOString()}
      />
    );
  }

  return (
    <SEO
      title="Leading Fire Safety Solutions"
      description="Kashyap Engineering - Your trusted partner for comprehensive fire safety solutions in India. Professional fire safety equipment, systems, and services meeting Indian Standards."
      keywords="fire safety solutions, fire safety equipment, fire extinguishers, fire alarms, sprinkler systems, fire safety services, fire protection, India, Kashyap Engineering"
      url="https://kashyapengineering.co.in"
      type="website"
      publishedTime={new Date().toISOString()}
    />
  );
};

function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-dark text-white overflow-x-hidden">
        {/* SEO Component */}
        <RouteSEO />
        
        {/* Enhanced Scroll Progress Indicator */}
        <motion.div
          className="fixed top-0 left-0 right-0 h-1 z-[60] bg-gradient-to-r from-primary via-secondary to-primary shadow-glow-red"
          style={{
            scaleX,
            transformOrigin: '0%',
          }}
        />
        
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <About />
                <Services />
                <Products />
                <Clients />
                <Contact />
              </>
            } />
            <Route path="/catalog" element={<Catalog />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
